module.exports = __webpack_public_path__ + "static/media/farming.0f380107.jpg";